import { z } from "zod";

export const MAX_COUNTERPARTY_REFERENCES = 20;

/**
 * One counterparty attached to a task-chat message.
 *
 * Snapshot fields are CLIENT-SUPPLIED AND UNVERIFIED — provided by the
 * browser at send time and NOT validated against server-side counterparty
 * data. Never use them for business logic or financial computations.
 * Treat as a display-only hint that may be stale or fabricated.
 */
export const CounterpartyReferenceSchema = z.object({
    /** Task the counterparty list belongs to */
    taskId: z.string().uuid(),
    counterpartyId: z.string().uuid(),
    /** Counterparty name snapshot captured at send time */
    counterpartyName: z.string().min(1).max(500),
    /**
     * Optional human-readable chip label, e.g. "Uber Technologies, Inc.".
     * Generated client-side for display; not required for persistence.
     */
    label: z.string().max(500).optional(),
});
export type CounterpartyReference = z.infer<typeof CounterpartyReferenceSchema>;

export function buildCounterpartyRefLabel(
    ref: Pick<CounterpartyReference, "counterpartyName">,
): string {
    return ref.counterpartyName;
}
